import { callAPI } from "../../../lib/common";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import LoadingButton from "../../../components/LoadingButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { FormHelperText } from "@material-ui/core";
import BoxActions from "./BoxActions";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import FormikTextField from "../../../components/Common/FormikTextField";
import Level2BoxContainer from "./Level2BoxContainer";
import Level2BoxHeading from "./Level2BoxHeading";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: theme.palette.secondary.main + " !important", // Because of desktop
    textTransform: "uppercase",
    marginBottom: theme.spacing(4),
    fontSize: "30px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  contentText: {
    fontSize: "20px",
    marginBottom: 0,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  form: {
    textAlign: "center",
    "& h4": {
      marginBottom: theme.spacing(4),
    },
    "& .MuiFormControl-root": {
      marginBottom: theme.spacing(4),
    },
    marginBottom: 0,
  },
  subjectName: {
    color: theme.palette.secondary.main,
    fontSize: "20px",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
      marginBottom: theme.spacing(2),
    },
  },
}));

export default ({
  email,
  codeInfo,
  handleUserExists,
  handleUserNotExists,
  onSetEmail,
  handleGoBack,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Level2BoxContainer>
      <Formik
        initialValues={{
          username: email,
        }}
        validationSchema={formSchema(t)}
        validateOnMount={true}
        onSubmit={(values, { setSubmitting, setFieldError, setValues }) => {
          const email = values.username.trim();
          setValues({ ...values, username: email });

          setSubmitting(true);
          callAPI(
            "/sections/prophoto/ajax/user_exists_by_email.php?email=" +
              encodeURIComponent(email),
          )
            .then((ret) => {
              if (ret.error) {
                console.log("Setting error", ret.error);
                setFieldError("username", ret.error);
              } else if (ret.exists) {
                onSetEmail(email);
                handleUserExists();
              } else {
                onSetEmail(email);
                handleUserNotExists();
              }
            })
            .finally(() => {
              setSubmitting(false);
            });
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form className={classes.form}>
              <Level2BoxHeading>
                <Trans>Code validated</Trans>
              </Level2BoxHeading>
              <Box mb={2}>
                <p className={classes.contentText}>
                  <Trans>
                    Please enter your email address to access the photos of
                  </Trans>
                </p>
                <div className={classes.subjectName}>{codeInfo.name}</div>
              </Box>

              <Field
                id="check-user-exists-email"
                component={FormikTextField}
                label={t("Email address")}
                name="username"
                variant="outlined"
                fullWidth
                autoFocus
              />
              <BoxActions>
                <Button
                  type="button"
                  variant="outlined"
                  color="primary"
                  onClick={handleGoBack}
                >
                  <Trans>Back</Trans>
                </Button>
                <LoadingButton
                  variant="primary"
                  isLoading={isSubmitting}
                  onClick={submitForm}
                  disabled={!isValid}
                  fullWidth
                >
                  <Trans>Ok</Trans>
                </LoadingButton>
              </BoxActions>
            </Form>
          );
        }}
      </Formik>
    </Level2BoxContainer>
  );
};

const formSchema = (t) => () => {
  return Yup.object().shape({
    username: Yup.string()
      .trim()
      .email(t("Invalid email"))
      .required(t("This is required!")),
  });
};
